<app-card [title]="'Enrollments'" [patientInfo]="{'patientAccountId': patientAccountId}">
    <div class="section">
        <div class="form-row">
            <div>
                <button class="button-Secondary" (click)="openModal()">+ New Enrollment</button>
            </div>
        </div>
    </div>
    <h4 class="salutation" style="margin-top: 30px;">Enrollments history</h4>
    <!-- New Enrollment section -->

    <!-- Loop through patient submissions -->
    <div *ngFor="let submission of patientSubmissions" class="form-row">
        <div class="submission">
            <p class="submission">
                Merck PAP - <span class="submission">{{submission.drugName}}</span>
            <p>Enrollment Status: <span class="status">{{ submission.status }}</span></p>
            <p class="date">
                {{ submission.status === 'Submitted' ? 
                  ('Process Duration Date: ' + (submission.processDurationDate | date:'MM/dd/yyyy')) : 
                  ('Expiry Date: ' + (submission.expiryDate ? (submission.expiryDate | date:'MM/dd/yyyy') : '')) }}
              </p>

        </div>

        <!-- Continue button styled with button-default -->
        <div *ngIf="submission.status === 'Not Submitted'">
            <button class="button-Primary" (click)="continue(submission)">Continue</button>
        </div>
        <div *ngIf="submission.status === 'Additional Documents Needed'">
            <button class="button-Primary" (click)="uploadDocument(submission.enrollmentId)">Upload Document</button>
        </div>
    </div>

    <!-- <div class="enrollment-image-section">
        <picture>
            <source srcset="assets/images/mobile/Enrollmentmobile.png" media="(max-width: 767px)" />
            <source srcset="assets/images/tablet/Enrollmenttablet.png"
                media="(min-width: 768px) and (max-width: 1023px)" />
            <img src="assets/images/desktop/Enrollmentdesktop.png" alt="Enrollment Banner"
                class="enrollment-banner-image" />
        </picture>
    </div> -->

    <img src="assets/images/desktop/Enrollmentdesk.png" alt="Enrollment Desk" class="enrollment-image" /> 

</app-card>
<loading-spinner *ngIf="isLoading"></loading-spinner>